<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="merchants"
      :options.sync="options"
      :server-items-length="totalMerchants"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        // showFirstLastPage: true,
      }"
      sort-by="id"
      :style="{ padding: '10px', height: '70vh' }"
      fixed-header
    >
      <template v-slot:[`body.prepend`]>
        <tr>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 pl-4 d-block d-sm-table-cell d-print-table-cell fixed-row"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-checkbox
                    class="ma-0"
                    dense
                    hide-details="true"
                    v-model="selectAllData"
                    @click="selectAll(selectAllData)"
                  />
                </div>
              </template>
              <span>Select All</span>
            </v-tooltip>
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.merchant_name"
              type="text"
              label="Nama"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.mid"
              type="text"
              label="MID"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.merchant_type"
              :items="listMerchantType"
              label="Type"
              item-text="text"
              item-value="value"
              @change="getData"
              @input="search.merchant_type = $event ? $event : ''"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.address"
              type="text"
              label="Alamat Lengkap"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.reference_number"
              type="text"
              label="Nomor Pengajuan"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-menu
              ref="dateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  label="Request Date"
                  v-bind="attrs"
                  @blur="search.created_at = parseDate(dateFormatted)"
                  v-on="on"
                  hide-details="true"
                  dense
                />
              </template>
              <v-date-picker
                v-model="search.created_at"
                no-title
                scrollable
                @input="dateMenu = false"
              >
                <v-spacer />
                <v-btn text color="primary" @click="dateMenu = false">
                  Cancel
                </v-btn>
              </v-date-picker>
            </v-menu>
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.task_type"
              :items="listTaskType"
              label="Jenis Pengajuan"
              item-text="text"
              item-value="value"
              @change="getData"
              @input="search.task_type = $event ? $event : ''"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-autocomplete
              clearable
              v-model="search.request_by"
              :items="itemsActiveUser"
              item-text="userID"
              item-value="id"
              label="Request_by"
              :loading="loadingActiveUser"
              :search-input.sync="searchActiveUser"
              @change="getData"
              hide-selected
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.status"
              :items="listStatus"
              label="Request Status"
              item-text="text"
              item-value="value"
              @change="getData"
              @input="search.status = $event ? $event : ''"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-chip
            v-if="selectedData.length > 0"
            close
            @click:close="clearSelected"
          >
            {{ `${selectedData.length} data(s) selected` }}
          </v-chip>
          <v-spacer />
          <template>
            <v-btn
              color="primary"
              class="mb-2"
              @click="openApproveModal"
              :style="{ 'margin-right': '10px' }"
              :disabled="loading"
              >Approve
            </v-btn>
            <v-btn
              color="warning"
              class="mb-2"
              @click="getData"
              :style="{ 'margin-right': '10px' }"
              :loading="loading"
              :disabled="loading"
              ><v-icon>mdi-restart</v-icon
              ><template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
            <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item link @click="exportExcel()">
                  <v-list-item-icon>
                    <v-icon>mdi-file-excel</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Export to excel</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="viewItem(item)"> mdi-eye </v-icon>
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
      <template v-slot:item="{ item, index }">
        <tr
          :key="index"
          :style="{ cursor: 'pointer' }"
          :class="selectedRow == index ? 'indigo lighten-5' : ''"
          @click="selectRow(index)"
        >
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-checkbox
              class="ma-0"
              dense
              hide-details="true"
              v-model="selectedData"
              :value="item.id"
              :disabled="!item.mid && item.merchant_type != 'Aggregator'"
            />
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchant_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mid }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchant_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.address }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.reference_number }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.created_at }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.task_type }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.request_by }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.status }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-icon small class="mr-2" @click="viewItem(item)">
              mdi-eye
            </v-icon>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="clearSearch"
          :disabled="loading"
          :loading="loading"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogApprove" width="500">
      <v-card>
        <v-card-title> Are you sure want to approve ? </v-card-title>
        <v-card-text> Caution: this action cannot be undone ! </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="approve"
            :disabled="loading"
            :loading="loading"
          >
            Approve
          </v-btn>
          <v-btn dark color="red" @click="() => (dialogApprove = false)">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {
  dataListMerchantCriteria,
  dataListMerchantType,
  dataListTaskType,
  dataListMwHoStatus,
  dataMaxSelectedApproval,
  dataDelayServiceHit,
} from '../../store/params';
import { date, showAlert } from '../../lib/helpers';

export default {
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogDelete: false,
    dialogApprove: false,
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'id',
        sortable: false,
        width: '10',
      },
      {
        text: '#',
        align: 'center',
        value: '#',
        sortable: false,
      },
      {
        text: 'Nama',
        value: 'merchant_name',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'MID',
        value: 'mid',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Type',
        value: 'merchant_type',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Alamat Lengkap',
        value: 'address',
        width: '250',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Nomor Pengajuan',
        value: 'reference_number',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Request Date',
        value: 'created_at',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Jenis Pengajuan',
        value: 'task_type',
        width: '200',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Request By',
        value: 'request_by',
        width: '150',
        align: 'start',
        sortable: false,
      },
      {
        text: 'Request Status',
        value: 'status',
        width: '200',
        align: 'start',
        sortable: false,
      },
      { text: 'Action', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    search: {
      merchant_name: '',
      mid: '',
      merchant_type: '',
      task_type: '',
      status: '',
      address: '',
      reference_number: '',
      created_at: null,
      request_by: '',
    },
    selectedRow: '',
    listMerchantCriteria: dataListMerchantCriteria,
    listMerchantType: dataListMerchantType,
    listTaskType: dataListTaskType,
    listStatus: dataListMwHoStatus,
    dateFormatted: '',
    dateMenu: false,
    searchActiveUser: '',
    selectedData: [],
    selectAllData: false,
    maxSelected: dataMaxSelectedApproval,
    delayHitService: null,
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.daftarTugas.ho.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.daftarTugas.ho.flashError;
      },
      set() {
        this.$store.commit('daftarTugas/ho/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.daftarTugas.ho.errors;
    },
    loading() {
      return this.$store.state.daftarTugas.ho.loading;
    },
    loadingActiveUser() {
      return this.$store.state.users.loadingActiveUser;
    },
    merchants() {
      return this.$store.state.daftarTugas.ho.allMerchants;
    },
    totalPage() {
      return this.$store.state.daftarTugas.ho.totalPage;
    },
    itemsActiveUser() {
      return this.$store.state.users.allActiveUser;
    },
    totalMerchants() {
      return this.$store.state.daftarTugas.ho.totalMerchants;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'search.created_at': {
      handler() {
        this.dateFormatted = this.formatDate(this.search.created_at);
        this.getData();
      },
    },

    searchActiveUser: {
      handler() {
        clearTimeout(this.delayHitService);
        this.delayHitService = setTimeout(() => {
          this.getActiveUser();
        }, dataDelayServiceHit);
      },
    },

    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },
    selectedData: {
      handler() {
        if (this.selectedData.length > this.maxSelected) {
          showAlert(
            this.$store,
            `Limit selected data is ${this.maxSelected} !`,
            'mdi-alert',
            'red'
          );
          this.selectedData.splice(
            this.maxSelected,
            this.selectedData.length - 1
          );
        }
        this.checkAllSelected();
      },
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.merchant_name = '';
      this.search.mid = '';
      this.search.merchant_type = '';
      this.search.task_type = '';
      this.search.status = '';
      this.search.address = '';
      this.search.reference_number = '';
      this.search.created_at = null;
      this.search.request_by = '';
      this.$nextTick(() => {
        this.getData();
      });
    },

    openApproveModal() {
      if (this.selectedData.length < 1) {
        this.dialogApprove = false;
        showAlert(this.$store, 'Data must be selected!', 'mdi-alert', 'red');
      } else {
        this.dialogApprove = true;
      }
    },

    selectAll(status) {
      this.$nextTick(() => {
        const allIds = this.merchants.map((val) => ({
          id: val.id,
          disable:
            val.mid || (!val.mid && val.merchant_type === 'Aggregator') ? 1 : 0,
        }));
        const filtered = allIds
          .filter((val) => !this.selectedData.includes(val.id) && val.disable)
          .map((v) => v.id);
        if (status) {
          this.selectedData = this.selectedData.concat(filtered);
        } else {
          this.selectedData = this.selectedData.filter(
            (val) => !allIds.map((v) => v.id).includes(val)
          );
        }
      });
    },

    clearSelected() {
      this.selectedData = [];
      this.selectAllData = false;
    },

    approve() {
      this.$store
        .dispatch('daftarTugas/ho/bulk_approve', {
          date,
          id: this.selectedData,
        })
        .then((res) => {
          if (res) {
            this.clearSelected();
            this.getData();
          }
        })
        .finally(() => {
          this.dialogApprove = false;
        });
    },

    getData() {
      this.$store.commit('daftarTugas/ho/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('daftarTugas/ho/fetchMerchants', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage < page) {
              if (this.totalPage == 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          }
        })
        .finally(() => {
          this.checkAllSelected();
        });
    },

    checkAllSelected() {
      const allIds = this.merchants.map((val) => val.id);
      const allSelected = allIds.filter(
        (val) => !this.selectedData.includes(val)
      );
      if (
        allSelected.length == 0 &&
        this.selectedData.length > 0 &&
        this.merchants.length > 0
      ) {
        this.selectAllData = true;
      } else {
        this.selectAllData = false;
      }
    },

    getActiveUser() {
      this.$store.dispatch('users/getActiveUser', {
        date,
        userID: this.searchActiveUser,
      });
    },

    viewItem(item) {
      this.$router.push(`/daftar-tugas/approver-2-list/view/${item.id}`);
    },

    closeFlash() {
      this.$store.commit('daftarTugas/ho/setFlashErrorMessage', '');
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    exportExcel() {
      if (this.totalMerchants < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
      } else {
        const { page, itemsPerPage } = this.options;

        this.$store.dispatch('exportExcel', {
          date,
          page,
          itemsPerPage,
          sortBy: ['id'],
          sortDesc: [true],
          search: this.search,
          countData: this.totalMerchants,
          module: 'ho-to-do-list',
          exportUrl: 'export/generate-export-file/index',
          exportController: 'export/get-export-file',
          sourceData: 'sql',
        });
      }
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
